/**
 * created by: llh
 */
"use strict";
angular.module("planningCenterRelevanceManuscriptModule", [])
    .controller("planningCenterRelevanceManuscriptCtrl", ['$scope', '$modalInstance', '$q', 'trsHttpService', 'modalDialog', 'selectedItem', 'storageListenerService', '$state', 'localStorageService', 'trsspliceString',
        function($scope, $modalInstance, $q, trsHttpService, modalDialog, selectedItem, storageListenerService, $state, localStorageService, trsspliceString) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    manuscriptLibrary: 'personal',
                    keyword: '',
                };

                $scope.data = {
                    selectedItem: selectedItem,
                    items: [],
                    selectedArray: [],
                    relatedChannelInfos: [],
                    fusionRouter: { //融合编辑器路由
                        "1": "fusionnews",
                        "2": "fusionatlas",
                        "4": "fusionlinkdoc",
                        "5": "fusionactivity",
                        "6": "fusiontopic",
                        "7": "fusionvideo",
                        "8": "fusionlive"
                    },
                    filterIsSelectedIds: '',
                };

                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 10,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                requestData().then(function() {
                    return getRelatedMediaIds(1);
                });
                listenStorage();
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenIwo(function() {
                    requestData();
                    storageListenerService.removeListener("iwo");
                }, $scope);
            }

            /**
             * [requestData 获取稿库列表]
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                var params;
                if ($scope.status.keyword == '') {
                    params = {
                        serviceid: 'mlf_releasesource',
                        PageSize: $scope.page.PAGESIZE,
                        CurrPage: $scope.page.CURRPAGE,
                    };
                    params.methodname = $scope.status.manuscriptLibrary == 'personal' ? 'queryPersonalRelease' : 'queryReceivedRelease';
                } else {
                    params = {
                        serviceid: 'mlf_hybasesearch',
                        searchParams: {
                            "PAGESIZE": $scope.page.PAGESIZE,
                            "PAGEINDEX": $scope.page.CURRPAGE,
                            "searchFields": [
                                { "searchField": "", "keywords": $scope.status.keyword },
                                { "searchField": "docType", "keywords": "" },
                                { "searchField": "timeType", "keywords": "" },
                                { "searchField": "docStatus", "keywords": "" },
                                { "searchField": "_sort", "keywords": "time" }
                            ]
                        },
                    };
                    params.methodname = $scope.status.manuscriptLibrary == 'personal' ? 'queryForIwoPersonalDoc' : 'queryForIwoReceivedDoc';
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.page = data.PAGER;
                    $scope.data.items = data.DATA;
                    $scope.data.selectedArray = [];
                    localStorageService.remove("iWo");
                    queryRelevanceManuscriptIDS();
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [queryRelevanceManuscriptIDS 查询任务关联稿件ID集合]
             * @return {[type]} [description]
             */
            function queryRelevanceManuscriptIDS() {
                var params = {
                    serviceid: 'mlf_taskcommand',
                    methodname: 'queryTaskCommandDocRels',
                    TaskId: $scope.data.selectedItem.TASKCOMMANDID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                	$scope.data.filterIsSelectedIds = data.METADATAIDS;
                    if (data.METADATAIDS != '') {
                        filterIsSelectedManuscript(data.METADATAIDS);
                    }
                });
            }

            /**
             * [filterIsSelectedManuscript 过滤已关联稿件]
             * @return {[type]} [description]
             */
            function filterIsSelectedManuscript(string) {
                for (var i = 0; i < $scope.data.items.length; i++) {
                    if (string.indexOf($scope.data.items[i].METADATAID) > -1) {
                        $scope.data.items[i].ISSELECTED = true;
                    } else {
                        $scope.data.items[i].ISSELECTED = false;
                    }
                }
            }

            /**
             * [getRelatedMediaIds description] 获取关联渠道的相关id
             * @param {[type]} [doctype] [description] 稿件类型
             * @return {[type]} [description]
             */
            function getRelatedMediaIds(doctype) {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_fusioncreate",
                    methodname: "getMediaTypesByDocType",
                    doctype: doctype
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.status.relatedChannelInfos = data;
                    defer.resolve(data);
                });
                return defer.promise;
            }

            /**
             * [chooseManuscriptLibrary 选择稿库]
             * @param  {[type]} library [description]
             * @return {[type]}         [description]
             */
            $scope.chooseManuscriptLibrary = function(library) {
                if ($scope.status.manuscriptLibrary == library) return;
                $scope.status.manuscriptLibrary = library;
                $scope.page.CURRPAGE = 1;
                requestData();
            };

            /**
             * [singleSelect 单选]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(item) {
                var n = $scope.data.selectedArray.indexOf(item);
                n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [selectAll 全选]
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
            	var noSelected = $scope.data.items.filter(function(item){
            		return item.ISSELECTED == false;
            	});
                if (($scope.data.items.length > 0 && $scope.data.items.length == $scope.data.selectedArray.length) || ($scope.data.items.length > 0 && $scope.data.selectedArray.length > 0 && $scope.data.selectedArray.length == noSelected.length)) {
                    $scope.data.selectedArray = [];
                } else {
                	var filterArray = $scope.data.items.filter(function(item, index){
                    	return item.ISSELECTED == false;
                    });
                    $scope.data.selectedArray = filterArray.length > 0 ? [].concat(filterArray) : [].concat($scope.data.items);
                }
            };



            /**
             * [querySearchByKeyword 关键字检索]
             * @param  {[type]} e [description]
             * @return {[type]}   [description]
             */
            $scope.querySearchByKeyword = function(e) {
                if (e.keyCode == 13 || angular.isUndefined(e.keyCode)) {
                    requestData();
                }
            };

            /**
             * [fusionEditor description] 融合编辑
             * @param {[type]} [doctype] [description] 稿件类型
             * @param {[type]} [iwometadataid] [description] 稿件metadataid
             * @param {[type]} [iwochnldocid] [description]
             * @return {[type]} [description]
             */
            $scope.fusionEditor = function(doctype, iwometadataid, iwochnldocid, item) { //person
                if (doctype == '9') {
                    var routerParams = {
                        iwoplatform: 0,
                        iwometadataid: iwometadataid,
                        iwochnldocid: iwochnldocid,
                        isfromplannedorder: false
                    }
                    url = $state.href('iwobroadcasttvmanuscript', routerParams);
                    window.open(url);
                } else if (doctype == '11') {
                    var routerParams = {
                        iwoplatform: 0,
                        iwometadataid: iwometadataid,
                        iwochnldocid: iwochnldocid,
                    }
                    url = $state.href('iwoplannedorderedit', routerParams);
                    window.open(url);
                } else {
                    var url,
                        routerParams = {
                            iwoplatform: 0,
                            wzplatform: 0,
                            appplatform: 0,
                            newspapertype: 2,
                            wxplatform: 0
                        };
                    angular.forEach($scope.status.relatedChannelInfos, function(value, key) {
                        if (value.MEDIATYPE == "1") {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                        } else if (value.MEDIATYPE == "2") {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                        } else if (value.MEDIATYPE == "3") {
                            routerParams.paperid = value.CHANNELID;
                        } else if (value.MEDIATYPE == "4") {
                            routerParams.wxchannelid = value.CHANNELID;
                        }
                    });
                    if (angular.isDefined(iwometadataid)) {
                        routerParams.iwometadataid = iwometadataid;
                        routerParams.iwochnldocid = iwochnldocid;
                        angular.forEach(item.relatedInfo, function(value, key) {
                            if (value.MEDIATYPE == "1") {
                                routerParams.appsiteid = value.SITEID;
                                routerParams.appchannelid = value.CHANNELID;
                                routerParams.appchnldocid = value.CHNLDOCID;
                                routerParams.appmetadataid = value.VIRTUALDOCID;
                            } else if (value.MEDIATYPE == "2") {
                                routerParams.wzsiteid = value.SITEID;
                                routerParams.wzchannelid = value.CHANNELID;
                                routerParams.wzchnldocid = value.CHNLDOCID;
                                routerParams.wzmetadataid = value.VIRTUALDOCID;
                            } else if (value.MEDIATYPE == "3") {
                                routerParams.paperid = value.CHANNELID;
                                routerParams.papermetadataid = value.VIRTUALDOCID;
                            } else if (value.MEDIATYPE == "4") {
                                routerParams.wxchannelid = value.CHANNELID;
                                routerParams.wxchnldocid = value.CHNLDOCID;
                                routerParams.wxmetadataid = value.VIRTUALDOCID;
                            } else if (value.MEDIATYPE == "5") {
                                routerParams.wbmetadataid = value.VIRTUALDOCID;
                            }
                        });
                        url = $state.href($scope.data.fusionRouter[doctype], routerParams);
                        window.open(url);
                    } else {
                        url = $state.href($scope.data.fusionRouter[doctype], routerParams);
                        window.open(url);
                    }
                }
            };

            /**
             * [fusionPreview description]  融合编辑 预览
             * @param  {[type]} doctype       [description]
             * @param  {[type]} iwometadataid [description]
             * @param  {[type]} iwochnldocid  [description]
             * @return {[type]}               [description]
             */
            $scope.fusionPreview = function(doctype, iwometadataid, iwochnldocid, item) { //wio
                if (doctype == '9') {
                    storageListenerService.previewPageTurningStorage($scope.data.items, "METADATAID,CHNLDOCID,DOCTYPEID", "fusionPreview"); //iwo
                    var routerParams = {
                        iwoplatform: 0,
                        iwometadataid: iwometadataid,
                        iwochnldocid: iwochnldocid,
                        isfromplannedorder: false
                    }
                    url = $state.href('iwomanuscriptpreview', routerParams);
                    item.url = url;
                } else if (doctype == '11') {
                    storageListenerService.previewPageTurningStorage($scope.data.items, "METADATAID,CHNLDOCID,DOCTYPEID", "fusionPreview"); //iwo
                    var routerParams = {
                        iwoplatform: 0,
                        iwometadataid: iwometadataid,
                        iwochnldocid: iwochnldocid,
                        isfromplannedorder: false
                    }
                    url = $state.href('iwoseriessheetpreview', routerParams);
                    item.url = url;
                } else {
                    storageListenerService.previewPageTurningStorage($scope.data.items, "METADATAID,CHNLDOCID,DOCTYPEID", "fusionPreview"); //iwo
                    var url,
                        routerParams = {
                            iwotype: doctype,
                            iwomodalname: "iwo.personal",
                            wzplatform: 0,
                            wztypeid: doctype,
                            appplatform: 0,
                            newspapertype: 2,
                            iwoplatform: 0,
                            iwometadataid: iwometadataid,
                            iwochnldocid: iwochnldocid,
                            wxplatform: 0
                        };

                    routerParams.appdoctype = doctype;
                    angular.forEach($scope.status.relatedChannelInfos, function(value, key) { //preview
                        if (value.MEDIATYPE == "1") {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                        } else if (value.MEDIATYPE == "2") {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                        } else if (value.MEDIATYPE == "3") {
                            routerParams.paperid = value.CHANNELID;
                        }
                    });
                    angular.forEach(item.relatedInfo, function(value, key) {
                        if (value.MEDIATYPE == "1") {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == "2") {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == "3") {
                            routerParams.paperid = value.CHANNELID; //预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; //预览页与编辑页参数不同
                        } else if (value.MEDIATYPE == "4") {
                            routerParams.wxchannelid = value.CHANNELID;
                            routerParams.wxchnldocid = value.CHNLDOCID;
                            routerParams.wxmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == "5") {
                            routerParams.wbmetadataid = value.VIRTUALDOCID;
                        }
                    });
                    url = $state.href('fusionpreview', routerParams);
                    item.url = url;
                }
            };

            /**
             * [confirm 保存关联稿件]
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                if ($scope.data.selectedArray.length == 0) {
                    modalDialog.alertType('请选择关联稿件', '', 'info', false);
                    return;
                }
                var params = {
                    serviceid: 'mlf_taskcommand',
                    methodname: 'saveTaskCommandDocRel',
                    TaskId: $scope.data.selectedItem.TASKCOMMANDID,
                    DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',')
                };
                if ($scope.data.filterIsSelectedIds != '') params.DocIds = params.DocIds + ',' + $scope.data.filterIsSelectedIds;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        $modalInstance.close(data);
                    } else {
                        modalDialog.alertType(data.DETAIL, '', 'error', false);
                    }
                });
            };

            /**
             * [pageChanged 切换分页]
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                requestData();
            };

            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);